/* eslint-disable react/jsx-no-useless-fragment */
import React, { FunctionComponent, ReactNode } from 'react';
import PageLayoutHeader, { PageLayoutHeaderProps } from './header/PageLayoutHeader';
import PageLayoutContent, { PageLayoutContentProps } from './content/PageLayoutContent';
import PageLayoutMain, { PageLayoutMainProps } from './main/PageLayoutMain';
import PageLayoutAside, { PageLayoutAsideProps } from './aside/PageLayoutAside';
import LayoutWrapper, { LayoutWrapperProps } from '../layout-wrapper/LayoutWrapper';
import PageLayoutBreadcrumb, { PageLayoutBreadcrumbProps } from './breadcrumb/PageLayoutBreadcrumb';
import { WrapperSize } from '../../types';

export const PageLayoutSize = WrapperSize;

export interface PageLayoutProps {
  children: ReactNode,
}

export interface PageLayoutComposition {
  Header: FunctionComponent<PageLayoutHeaderProps>,
  Breadcrumb: FunctionComponent<PageLayoutBreadcrumbProps>,
  Content: FunctionComponent<PageLayoutContentProps>,
  Main: FunctionComponent<PageLayoutMainProps>,
  Aside: FunctionComponent<PageLayoutAsideProps>,
  Wrapper: FunctionComponent<LayoutWrapperProps>,
}

const PageLayout: FunctionComponent<PageLayoutProps> & PageLayoutComposition = ({
  children,
}) => <>{children}</>;

PageLayout.Header = PageLayoutHeader;
PageLayout.Breadcrumb = PageLayoutBreadcrumb;
PageLayout.Content = PageLayoutContent;
PageLayout.Main = PageLayoutMain;
PageLayout.Aside = PageLayoutAside;
PageLayout.Wrapper = LayoutWrapper;

export default PageLayout;
